import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, signal } from '@angular/core';
import { Task } from '@models';
import { TaskService, AppService } from '@services';
import { SceneStore } from '@stores';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-task-panel',
  templateUrl: './task-panel.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule],
})
export class TaskPanelComponent {
  taskList = input.required<Task[]>();

  protected appService = inject(AppService);
  protected taskService = inject(TaskService);
  protected sceneStore = inject(SceneStore);

  constructor() {
    effect(() => {
      this.scrollTo(this.taskService.currentTaskId());
    });
  }

  taskListExpanded = signal(true);

  scrollTo(targetId: string): void {
    if (targetId) {
      setTimeout(() => {
        document.getElementById(targetId).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 600);
    }
  }
}
